import React from 'react';
import { Redirect, Route } from 'react-router';

const PrivateRoute = ({ children, ...rest }) => {
    return (
        <>
            <Route
                {...rest}
                render={({ location }) =>
                    JSON.parse(sessionStorage.getItem('login'))?.email ||
                        JSON.parse(sessionStorage.getItem('login'))?.name ? (
                        children
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: { from: location }
                            }}
                        />
                    )
                }
            />
        </>
    );
};

export default PrivateRoute;